import React from 'react';

// Subtle brand flourish, a thin muted-copper ECG line echoing the LyphLine logo mark.
// Intentionally understated: faded flanking rules + one small heartbeat blip.
export const HeartbeatDivider = ({ className = '' }) => (
  <div className={`flex items-center justify-center ${className}`} aria-hidden="true">
    <span className="h-px w-12 sm:w-16 bg-[#CE8946]/25" />
    <svg width="110" height="18" viewBox="0 0 110 18" fill="none" className="mx-2 flex-shrink-0">
      <path
        d="M0 9 H38 l4 -6 l5 11 l4 -8 l4 3 H110"
        stroke="#CE8946" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" opacity="0.65"
      />
    </svg>
    <span className="h-px w-12 sm:w-16 bg-[#CE8946]/25" />
  </div>
);

export default HeartbeatDivider;
